const state = () => ({
  allData: [],
  totalData: 0,
  loading: false,
  totalPage: 0,
  requestData: null,
});

export default state;
